import type { SiteBatchUpdateDto } from "src/app/features/Site/types/SiteBatchUpdateDto";
import type { SiteBatchUpdateEntity } from "src/app/features/Site/types/SiteBatchUpdateEntity";

export const SiteBatchUpdateEntityToBatchUpdateDto = ({ ...rest }: Readonly<SiteBatchUpdateEntity>): SiteBatchUpdateDto => {
    return { ...rest };
};
